import React from 'react'

import { ROUTE_NAME, API_URL } from '../constants'

import ItemDelete from '../../../components/Delete'

const IncidentCategoryBufferDelete = () => (
  <ItemDelete
    routeName={ROUTE_NAME}
    apiUrl={API_URL}
    label={(item) =>
      `Category Buffer (#${item.id}): ${item.category.name} - ${item.aiLayer.name} - ${item.distance} ${item.unit}`
    }
  />
)

export default IncidentCategoryBufferDelete
